var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDesktop)?_c('expandable-image',{staticClass:"post-image",attrs:{"src":_vm.imageUrl,"alt":"Post Image"}}):_c('img',{staticClass:"post-image",attrs:{"src":_vm.imageUrl,"alt":"Post Image"}})}
var staticRenderFns = []

export { render, staticRenderFns }